/**
 * Espejo público del rol: usuarios_rol/{uid} = { rol, alcance }.
 *
 * users/{uid} solo lo leen el propio usuario y root, así que quien ajusta a
 * otra persona (supervisora con alcance, admin, auxiliar) no podría saber su
 * rol. Este espejo es legible con sesión. NO guarda el rango: sale de
 * roles/{rol}.rango, para que cambiar el rango de un rol no obligue a
 * reescribir espejos.
 */
import { applyUserScope } from './user_scope';

export const ROLE_MIRROR = 'usuarios_rol';

export const roleMirrorRef = (db, uid) => db.collection(ROLE_MIRROR).doc(uid);

export const roleMirrorData = (rolRef, alcance) => ({
  rol: rolRef.id,
  alcance: alcance === 'empresas' ? 'empresas' : 'todas',
});

/**
 * Rol del usuario objetivo con su alcance aplicado, o null si el espejo o el
 * rol faltan o no se pueden leer. Nunca rechaza.
 */
export const loadTargetRole = async ({ db, uid }) => {
  try {
    const mirrorSnap = await roleMirrorRef(db, uid).get();
    if (!mirrorSnap.exists) return null;
    const mirror = mirrorSnap.data();
    if (!mirror || typeof mirror.rol !== 'string' || !mirror.rol) return null;
    const roleSnap = await db.collection('roles').doc(mirror.rol).get();
    if (!roleSnap.exists) return null;
    return { ...applyUserScope(roleSnap.data(), { Alcance: mirror.alcance }), id: mirror.rol };
  } catch (e) {
    return null;
  }
};
